import React from 'react';
import classNames from 'classnames';
import icError from 'assets/svg/ic_error_2.svg';
import styles from './styles.module.scss';

const ErrorMessage = ({
  className,
  description
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icError
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, description));
};

export default ErrorMessage;